import React, {useState} from "react";
import "./MessageCardStyles.scss";

type ModalProps = {
    sender: string;
    role: string;
    message: string;
    date: string;
}

export const MessageCard = (props: ModalProps) => {
    return (
        <div className='message' style={props.role === 'client' ? {alignSelf: 'end'} : {alignSelf: 'start'}}>
            <div>{props.message}</div>
            <div className='small-text'>Отправлeно {props.sender} {props.date}</div>
        </div>
    )
}